import React, { useState } from "react";
import Modal from "react-modal";
import { customModalStyles } from "_shared/components/Modal/ModalStyles";
import UpsellModal from "dashboard/_root/components/UpsellModal/UpsellModal";

Modal.setAppElement("#root");

function TickerAlert({
  ticker,
  response,
  modalOpen,
  setModalOpen,
  setRefreshTable,
}) {
  const [upgrade, setUpgrade] = useState(false);
  const maximumMessage = {
    tickerWarningImage: "fas fa-times-circle",
    tickerWarningHeader: `You have reached the maximum number of tickers`,
    tickerWarningDescription: response.upgrade_message,
    tickerWarningButtonText: `Upgrade to Longbow ${response.upgrade_plan_title}`,
  };

  const warningMessage = {
    tickerWarningImage: "fas fa-exclamation-triangle",
    tickerWarningHeader: `Ticker ${ticker} has been added to your dashboard`,
    tickerWarningDescription: `You have ${response.tickers_left} ticker${
      response.tickers_left === 1 ? "" : "s"
    } remaining in your subscription. You may add ${
      response.total_tickers
    } new tickers each billing cycle. ${response.upgrade_message}`,
    tickerWarningButtonText: `Upgrade to Longbow ${response.upgrade_plan_title}`,
    tickerWarningMasterPlan: `You have ${response.tickers_left} ticker${
      response.tickers_left === 1 ? "" : "s"
    } left to reach the maximum tickers allowed in Longbow.`,
  };

  const message = response.tickers_left === 0 ? maximumMessage : warningMessage;

  return (
    <>
      <Modal
        isOpen={modalOpen}
        onRequestClose={() => {
          setUpgrade(false);
          setModalOpen(false);
        }}
        style={customModalStyles}
      >
        <div className="longbow-modal">
          <div className="longbow-modal-content" style={{ height: 408 }}>
            <i
              onClick={() => {
                setUpgrade(false);
                setModalOpen(false);
                setRefreshTable(new Date());
              }}
              className="fas fa-times"
              style={{
                position: "absolute",
                right: 15,
                top: 15,
                color: "#75ce41",
                cursor: "pointer",
              }}
            />
            {/* Ticker Top Image */}
            <i
              className={`justify-center ${message.tickerWarningImage}`}
              style={{
                color: response.tickers_left === 0 ? "#d33541" : "#75ce41",
                fontSize: 50,
                margin: "20px auto",
              }}
            />
            {/* Ticker Header */}
            <div
              className="longbow-tabs-text"
              style={{
                textAlign: "center",
                fontSize: 25,
                fontWeight: "bold",
                paddingBottom: 20,
              }}
            >
              {message.tickerWarningHeader}
            </div>
            {/* Description that says the amount of tickers left */}
            <div
              className="add-tab-small-text"
              style={{
                textAlign: "center",
                fontSize: 16,
                color: "white",
                height: 100,
              }}
            >
              {message.tickerWarningDescription}
            </div>
            <div
              className="longbow-tab-buttons"
              style={{ margin: 0, paddingTop: 14 }}
            >
              <div
                className="longbow-button-save"
                style={{
                  width: "80%",
                  margin: "auto",
                  display: "flex",
                }}
                onClick={() => {
                  setUpgrade(true);
                  setModalOpen(false);
                }}
              >
                {message.tickerWarningButtonText}
              </div>
            </div>
          </div>
        </div>
      </Modal>
      {upgrade && (
        <UpsellModal
          upgradeToPlan={response.upgrade_plan_key}
          setUpgrade={setUpgrade}
        />
      )}
    </>
  );
}
export default React.memo(TickerAlert);
